<template>
  <div style="background-color: #fff; padding: 0 10px 10px 10px">
    <!-- 搜索 -->
    <div ref="topDom" class="header-bar">
      <div class="bar-lef">
        <div class="lef-one">
          <a-select
              v-model:value="searchForm.status"
              allowClear
              placeholder="状态"
              @change="getTableData"
          >
            <a-select-option :value="0">全部</a-select-option>
            <a-select-option :value="1">通过</a-select-option>
            <a-select-option :value="2">不通过</a-select-option>
          </a-select>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.order_no"
              allowClear placeholder="订单号|外部单号"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.name"
              allowClear
              placeholder="姓名"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.idcard"
              allowClear
              placeholder="证件号"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.hid"
              allowClear
              placeholder="房间ID"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input-search
              v-model:value="searchForm.keyword"
              :loading="searchLoading"
              placeholder="房间名称|同住人|手机号"
              @search="getTableData"
          >
          </a-input-search>
        </div>
        <div class="lef-one-no-shadow">
          <a-button type="link" @click="handleReset">重置筛选</a-button>
        </div>
      </div>
      <div class="bar-rig">
        <div class="rig-one">
          <a-popover
              v-model:visible="visiblePopover"
              placement="bottom"
              trigger="click"
          >
            <template #content>
              <template v-for="(item, index) in initColumns" :key="index">
                <div v-if="item.title" style="margin: 5px 0">
                  <a-checkbox v-model:checked="item.isShow">{{
                      item.title
                    }}
                  </a-checkbox>
                </div>
              </template>
              <a-button
                  size="small"
                  style="margin-right: 5px"
                  @click="handleResetCheck"
              >重置
              </a-button
              >
              <a-button class="btn-primary" size="small" @click="handleCheck"
              >确认
              </a-button
              >
            </template>
            <a-button>
              <appstore-outlined/>
              视图
            </a-button>
          </a-popover>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="searchLoading"
        :pagination="false"
        :scroll="{ x: columns.length > 8 ? columns.length*130 : 0, y: tableHeight }"
        bordered
        class="table"
        size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key == 'order_no'">
          <a-button
              type="link"
              @click="
              detShow = true;
              orderId = record.order_id;
            "
          >{{ record.order_no }}
          </a-button
          >
        </template>
      </template>
    </a-table>

    <!-- 分页 -->
    <MyPagination
        :pageTotal="pageTotal"
        @onShowSizeChange="onShowSizeChange"
        @pageChange="pageChange"
    />

    <!-- 订单详情 -->
    <order-details
        v-model:visible="detShow"
        :orderId="orderId"
        @refreshOrderDetails="refresh"
    />
  </div>
</template>

<script>
import OrderDetails from "@/components/pms/landlord/OrderDetails/OrderDetails.vue";
import {nextTick, onMounted, reactive, toRefs, watch} from "vue";
import {tenantList,} from "@/api/api";
import {AppstoreOutlined,} from "@ant-design/icons-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库
import store from "@/store/pms/landlord/index";

export default {
  components: {
    AppstoreOutlined,
    OrderDetails,
  },
  setup() {
    let {countTable} = useUtils();

    // 搜索
    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        status: [],
        hid: '',
        idcard: '',
        keyword: "",
        order_no: "",
        start: 0,
        limit: 20,
      },
      rangePicker: [],
      visiblePopover: false,
      searchList: {
        deposit: {},
        group: {},
        income: {},
        inout: {},
        paytype: {},
        room: {},
        source: {},
        tag: {},
      },
      handleReset() {
        search.searchForm.keyword = "";
        search.searchForm.order_no = "";
        search.searchForm.hid = "";
        search.searchForm.status = "";
        search.searchForm.name = "";
        table.getTableData();
      },
      handleCheck() {
        table.columns = table.initColumns.filter((item) => {
          return item.isShow;
        });
        search.visiblePopover = false;
      },
      handleResetCheck() {
        table.initColumns.map((item) => {
          item.isShow = true;
        });
        table.columns = JSON.parse(JSON.stringify(table.initColumns));
        search.visiblePopover = false;
      },
      groupFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
      roomFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
    });

    function getColumns() {
      return [
        {
          title: "订单号",
          dataIndex: "order_no",
          key: "order_no",
          width: 120,
          isShow: true,
          align: "center",
        },
        {
          title: "房间",
          dataIndex: "hname",
          key: "payNo",
          width: 120,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "入住时间",
          dataIndex: "start_date",
          key: "start_date",
          width: 150,
          customRender: ({record}) => {
            return record.start_date + " - " + record.end_date;
          },
          isShow: true,
        },
        {
          title: "用户ID",
          dataIndex: "user_id",
          key: "user_id",
          width: 60,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "姓名",
          dataIndex: "name",
          key: "name",
          width: 80,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "手机号",
          dataIndex: "phone",
          key: "phone",
          width: 80,
          isShow: true,
          align: "center",
        },
        {
          title: "证件类型",
          dataIndex: "type_text",
          key: "type_text",
          width: 60,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "身份证号",
          dataIndex: "idcard",
          key: "idcard",
          width: 120,
          isShow: true,
          align: "center",
        },
        {
          title: "登记时间",
          dataIndex: "create_time",
          key: "create_time",
          width: 120,
          isShow: true,
          align: "center",
        },
        {
          title: "性别",
          dataIndex: "sex_text",
          key: "sex_text",
          width: 60,
          isShow: true,
          align: "center",
        },
        {
          title: "订单状态",
          dataIndex: "status_text",
          key: "status_text",
          width: 100,
          isShow: true,
          align: "center",
        },
        {
          title: "比对分数",
          dataIndex: "score",
          key: "score",
          width: 60,
          isShow: true,
          align: "center",
        },
        {
          title: "核验状态",
          dataIndex: "is_verify",
          key: "is_verify",
          width: 60,
          isShow: true,
          align: "center",
          customRender: ({record}) => {
            if (record.is_verify == 1) {
              return '通过';
            } else {
              return '不通过';
            }
          },
        },
        {
          title: "是否未成年",
          dataIndex: "minority",
          key: "minority",
          width: 80,
          isShow: true,
          align: "center",
          customRender: ({record}) => {
            if (record.minority == 1) {
              return '未成年';
            } else {
              return '已成年';
            }
          },
        },
        {
          title: "监护人关系",
          dataIndex: "guarder_rela",
          key: "guarder_rela",
          width: 100,
          isShow: true,
          align: "center",
          customRender: ({record}) => {
            if (record.guarder_rela == 1) {
              return '父亲';
            } else if (record.guarder_rela == 2) {
              return '母亲';
            } else if (record.guarder_rela == 3) {
              return '老师';
            } else if (record.guarder_rela == 9) {
              return '其他';
            } else {
              return '-';
            }
          },
        },
        {
          title: "监护人姓名",
          dataIndex: "guarder_name",
          key: "guarder_name",
          width: 80,
          isShow: true,
          align: "center",
        },
        {
          title: "监护人证件",
          dataIndex: "guarder_idcard",
          key: "guarder_idcard",
          width: 150,
          isShow: true,
          align: "center",
        },
        {
          title: "监护人电话",
          dataIndex: "guarder_phone",
          key: "guarder_phone",
          width: 80,
          isShow: true,
          align: "center",
        },
        {
          title: "是否有同住人",
          dataIndex: "cohabit_has",
          key: "cohabit_has",
          width: 80,
          isShow: true,
          align: "center",
          customRender: ({record}) => {
            if (record.cohabit_has == 1) {
              return '有同住人';
            } else {
              return '无同住人';
            }
          },
        },
        {
          title: "同住人关系",
          dataIndex: "cohabit_rela",
          key: "cohabit_rela",
          width: 80,
          isShow: true,
          align: "center",
          customRender: ({record}) => {
            if (record.cohabit_rela == 1) {
              return '监护人';
            } else if (record.cohabit_rela == 2) {
              return '同学';
            } else if (record.guarder_rela == 9) {
              return '其他';
            } else {
              return '-';
            }
          },
        },
        {
          title: "是否可疑",
          dataIndex: "suspicious",
          key: "suspicious",
          width: 80,
          isShow: true,
          align: "center",
          customRender: ({record}) => {
            if (record.suspicious == 1) {
              return '是';
            } else {
              return '否';
            }
          },
        },
        {
          title: "可疑描述",
          dataIndex: "suspicious_remark",
          key: "suspicious_remark",
          width: 150,
          isShow: true,
          align: "center",
          ellipsis: true,
        },
        {
          title: "核验错误",
          dataIndex: "is_verify_msg",
          key: "is_verify_msg",
          width: 150,
          isShow: true,
          align: "center",
          ellipsis: true,
        },
      ];
    }

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableData();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableData();
      },
    });

    // 表格
    const table = reactive({
      currentItem: {},
      tableHeight: "",
      dataSource: [],
      topData: {},
      initColumns: [],
      getTableData() {
        search.searchLoading = true;
        tenantList(search.searchForm)
            .then((res) => {
              table.dataSource = res.data.list;
              pagination.pageTotal = res.data.count;
              nextTick(() => {
                table.columns = getColumns();
                table.initColumns = getColumns();
              });
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      columns: [
        {
          title: "订单号",
          dataIndex: "order_no",
          key: "order_no",
          width: 150,
          align: "center",
        },
        {
          title: "商户单号",
          dataIndex: "payNo",
          key: "payNo",
          width: 150,
          align: "center",
        },
        {
          title: "房号",
          dataIndex: "name",
          key: "name",
          width: 200,
        },
        {
          title: "入住时间",
          dataIndex: "start_date",
          key: "start_date",
          width: 200,
        },
        {
          title: "客人",
          dataIndex: "checkIn",
          key: "checkIn",
          width: 200,
          align: "center",
        },
        {
          title: "押金（元）",
          dataIndex: "amount",
          key: "amount",
          width: 100,
        },
        {
          title: "已退（元）",
          dataIndex: "refund_amount",
          key: "refund_amount",
          width: 100,
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          width: 100,
          customRender: ({record}) => {
            if (record.status == 1) {
              return record.status_text;
            } else if (record.status == 2 && record.refund_status == 0) {
              return record.status_text;
            } else if (record.status == 2 && record.refund_status != 0) {
              return record.refund_status_text;
            }
          },
        },
        {
          title: "",
          dataIndex: "operate",
          key: "operate",
          width: 200,
        },
      ],
    });

    // 订单
    const order = reactive({
      detShow: false,
      orderId: "",
      refresh() {
        table.getTableData();
      },
    });


    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 15;
        }
    );

    onMounted(() => {
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 15;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(pagination),
      ...toRefs(order),
    };
  },
};
</script>

<style lang="scss" scoped>
.refund {
  .refund-switch {
    display: flex;
    align-items: center;
    cursor: pointer;

    .switch-lef {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 6px 0 0 6px;
      width: 100px;
      text-align: center;
    }

    .switch-rig {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 0 6px 6px 0;
      width: 100px;
      text-align: center;
    }

    .refundSel {
      background-color: #1890ff;
      color: #fff;
      border: none;
    }
  }
}

.head-box {
  margin-bottom: 10px;
  font-weight: bold;
}

.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}
</style>
